import React from 'react';
import PropTypes from 'prop-types';

import { Title, Card, CardContent, Loader } from '@common/components';

import { useTranslation } from 'react-i18next';

import viewClasses from './NotResults.module.scss';

export default function NotResults({ card, isLoading }) {
  const { t } = useTranslation('dashboard\\NotResults');

  return card && !isLoading ? (
    <Card>
      <CardContent className={viewClasses.content}>
        <Title color="grey-400">
          {isLoading ? <Loader /> : t('noResults')}
        </Title>
      </CardContent>
    </Card>
  ) : (
    <Title color="grey-400" className={viewClasses.content}>
      {isLoading ? (
        <Loader size="big" message={t('loadingMessage')} />
      ) : (
        t('noResults')
      )}
    </Title>
  );
}

NotResults.propTypes = {
  card: PropTypes.bool,
  isLoading: PropTypes.bool,
};
